<template>
  <img :src="imageURL" :alt="alt" :width="width" :height="height">
</template>

<script>
export default {
  name: 'create-page-image',
  props: {
  	imageURL: {
  	  type: String,
  	  default: ""
  	},
  	alt: {
  	  type: String,
  	  default: "YeyPass"
  	},
  	width: {
  		type: String,
  		default: "100%"
  	},
  	height: {
  		type: String,
  		default: "auto"
  	}
  
  }
}
</script>


// WEBPACK FOOTER //
// src/components/common/CreatePageImage.vue